
import { defineComponent, reactive, ref, inject } from "vue";
import { Toast } from "@/utils";
import { updateFQC } from '@/request/view/warehouse.js';
import { modelSpecificationsOption, checkTypeInProject } from '@/views/productDaily/serve/option'
import { validateFQCBatch } from '@/views/productDaily/components/instruction/validate';

interface fQC {
  assembleDebugsnNumber: string,
  batchNumber: string,
  closedLoopStatus: string,
  id: number,
  inspectionFrequency: number,
  inspectionIssues: string,
  localDate: string,
  modelSpecifications: string,
  notes: string,
  pqcId: number,
  produceOrTpc: string,
  serial: string,
  serialNumber: string,
  status: string,
  userId: number,
  username: string,
}

export default defineComponent({
  setup(props, context) {
    const formRef = ref();
    const modelSpecifications = ref([]);
    const formState: fQC = reactive({
      serial: null,
      assembleDebugsnNumber: null,
      batchNumber: null,
      closedLoopStatus: null,
      inspectionFrequency: null,
      inspectionIssues: null,
      localDate: null,
      id: null,
      modelSpecifications: null,
      notes: null,
      pqcId: null,
      produceOrTpc: inject('produceOrTpc', null),
      serialNumber: null,
      status: null,
      userId: null,
      username: null,
    });

    const rules = {
      serial: [{ required: true, message: '请输入机身号', trigger: "change" }],
      localDate: [{ required: true, message: '请选择生产日期', trigger: "change" }],
      modelSpecifications: [
        { required: true, message: '请选择设备型号', trigger: "change" },
      ],
      batchNumber: [{
        required: true,
        whitespace: true,
        validator: validateFQCBatch,
        trigger: "blur",
        type: "string",
      }],
    };

    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const showModal = (type, options) => {
      const { title, data } = options;

      if (type === "insert") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }

      if (formState.modelSpecifications) {
        const project = checkTypeInProject(formState.modelSpecifications);
        modelSpecifications.value.push(project.value, formState.modelSpecifications);
      }

      modalConfig.title = title;
      modalConfig.visible = true;

      console.log(formState, 'formState');
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formState.produceOrTpc = inject('produceOrTpc', null);
      modelSpecifications.value.length = 0;
      formRef.value.clearValidate();
    };

    const handleOk = () => {
      formRef.value
        .validateFields()
        .then(() => {
          updateFQC({ isQualityInspection: 0 }, formState).then((res: any) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            handleCancel();
            context.emit("handleUpdateTable");
          });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    };

    const handleSelectModel = (e) => {
      const [project, model] = e;
      if (project && model) {
        formState.modelSpecifications = model;
        return
      }
      formState.modelSpecifications = null;
    };

    const handleSelectDate = (e, stringTime) => {
      formState.localDate = stringTime;
    };

    return {
      formState,
      rules,
      formRef,
      showModal,
      handleCancel,
      handleOk,
      modalConfig,
      modelSpecifications,
      handleSelectModel,
      handleSelectDate,
      modelSpecificationsOption,
    };
  },
});
